import { useReactiveVar } from '@apollo/client';
import { ModuleLoading } from '@starryui10/Loading/ModuleLoading';
import React from 'react';
import styled from 'styled-components';
import { loadingDirectory } from '../../state/Observables';

export const Loading = () => {
    const visible = useReactiveVar(loadingDirectory);
    return (
        <StyledDiv visible={visible}>
            <ModuleLoading />
        </StyledDiv>
    );
};

const StyledDiv = styled.div<{ visible: boolean }>`
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.6);
    left: 0;
    visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
`;
